import isHistoryArchivalEnabled from './is-history-archival-enabled';
import isVisibilityArchivalEnabled from './is-visibility-archival-enabled';

export default namespaceSettings =>
  isHistoryArchivalEnabled(namespaceSettings) &&
  isVisibilityArchivalEnabled(namespaceSettings);



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/is-archival-enabled.js